import SesamyNivoTheme from "@/components/Nivo/SesamyNivoTheme";
import { gradient } from "@/constants/color-gradient";
import { numberFormat } from "@/utils/numberFormat";
import dynamic from "next/dynamic";

const ResponsivePie = dynamic(
  () => import("@nivo/pie").then(({ ResponsivePie }) => ResponsivePie),
  { ssr: false },
);

type PieDataItem = {
  id?: string;
  ratio?: number;
  value?: number;
};

const transform = (data: PieDataItem[]) => {
  const hasKlarna = data.some(({ id }) => id === "Klarna");
  const hasStripeKlarna = data.some(({ id }) => id === "Stripe_Klarna");
  const shouldFilterStripeKlarna = hasKlarna && hasStripeKlarna;

  return data
    .filter(({ id }) => !(shouldFilterStripeKlarna && id === "Stripe_Klarna"))
    .map(({ ratio, id, value }) => ({
      id,
      value: ratio || value,
    }));
};

const Pie = ({
  data,
  fullyRendered = () => {},
}: {
  data: any;
  fullyRendered?: Function;
}) => {
  data = transform(data);
  const colors = Object.values(gradient) as string[];

  return (
    <div className="aspect-[1.8/1] w-full">
      <ResponsivePie
        layers={[
          "arcs",
          "arcLinkLabels",
          "arcLabels",
          "legends",
          () => fullyRendered(),
        ]}
        colors={colors}
        theme={SesamyNivoTheme}
        enableArcLinkLabels={false}
        data={data}
        margin={{ top: 8, right: 0, bottom: 8, left: 0 }}
        innerRadius={0.5}
        padAngle={0}
        cornerRadius={0}
        activeOuterRadiusOffset={8}
        borderWidth={0}
        borderColor={{
          from: "color",
          modifiers: [["darker", 0.2]],
        }}
        arcLinkLabelsSkipAngle={10}
        arcLinkLabelsTextColor="#333333"
        arcLinkLabelsThickness={2}
        arcLinkLabelsColor={{ from: "color" }}
        arcLabelsSkipAngle={10}
        arcLabel={({ value }) => numberFormat(value)}
        defs={[
          {
            id: "dots",
            type: "patternDots",
            background: "inherit",
            color: "rgba(255, 255, 255, 0.3)",
            size: 4,
            padding: 1,
            stagger: true,
          },
          {
            id: "lines",
            type: "patternLines",
            background: "inherit",
            color: "rgba(255, 255, 255, 0.3)",
            rotation: -45,
            lineWidth: 6,
            spacing: 10,
          },
        ]}
        motionConfig="stiff"
        legends={[
          {
            anchor: "left",
            direction: "column",
            symbolShape: "circle",
            justify: false,
            translateX: 0,
            translateY: 0,
            itemWidth: 100,
            itemHeight: 20,
            itemsSpacing: 8,
            symbolSize: 10,
            itemDirection: "left-to-right",
          },
        ]}
      />
    </div>
  );
};

export default Pie;
